export default {"src":"/_next/static/media/browser-side-bar.f836dcbb.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};